<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">

                <div class="form-row">
                    <div class="col-md-11">
                        <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.gasstation.list.label.title')}}</h4></h4>
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>

                <p class="sub-header">
                    {{$t('string.msg.gasstation.search.description')}}
                </p>

                <form>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="inputAddress" class="col-form-label">
                                {{$t('string.msg.gasstation.search.label.name')}}
                            </label>
                            <input type="text" v-model="filters.name" class="form-control">
                        </div>

                        <div class="form-group col-md-4">
                            <label class="col-form-label">
                                <code class="highlighter-rouge">*</code>
                                {{$t('string.msg.gasstation.label.status')}}
                            </label>
                            <select v-model="filters.status" class="form-control">
                                <option :value="null" selected>{{$t('string.msg.element.select.selectitem')}}</option>
                                <option value="ACTIVE">{{$t('string.msg.active')}}</option>
                                <option value="ARCHIVED">{{$t('string.msg.archived')}}</option>
                            </select>
                        </div>
                    </div>
                    <br/>
                    <div class="d-flex justify-content-between bd-highlight mb-3">
                        <button @click="filter" class="btn btn-success w-20">{{$t('string.msg.form.btn.search')}}</button>
                    </div>
                </form>

                <div class="pb-0 pt-3 cursor-pointer">
                    <jw-pagination :items="items" @changePage="onChangePage" :labels="customLabels"></jw-pagination>
                </div>
                <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0">{{$t('string.msg.gasstation.label.name')}}</th>
                                <th class="border-top-0">{{$t('string.msg.gasstation.label.latitude')}}</th>
                                <th class="border-top-0">{{$t('string.msg.gasstation.label.longitude')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="item._id" v-for="item in pageOfItems" class="cursor-pointer" @click="selectItem(item)">
                                <td>
                                    <span>
                                        {{toUpperCase(item.name)}}
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        {{(item.latlng.latitude)}}
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        {{(item.latlng.longitude)}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
           <Toast :title="titleToast" :message="messageToast" />
    </div>
</template>

<script>
import Controller from './CrtListGasStation';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);
import Vue from 'vue'
Vue.prototype.$eventHub = new Vue();
export default {
  name: 'ListGasStation',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
    Spinner,
    Toast,
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        PageNumbers:1,
        items: [],
        pageOfItems: [],
        filters: {
            name: "",
            status:'ACTIVE',
            skip: 0,
            limit: 999999
        },
        customLabels: {
            first: 'Primeira',
            last: 'Último',
            previous: 'Anterior',
            next: 'Próxima'
        },
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
    let state = this;
    this.$eventHub.$on('refreshList', function(){
        state.filter();
    })
  },
  mounted(){
  }
}
</script>

<style>
</style>
